<form novalidate #currentForm="ngForm">
  <div class="row">
    <div class="col">
      <div class="form-group border-bottom py-2" [ngClass]="{ 'border-top': !address.id }">
        <label>Quick Search</label>
        <textarea class="form-control" name="quick_search" [(ngModel)]="quickSearch" placeholder="Type or paste all or part of an address and click on 'Quick Search'" [disabled]="geocoding"></textarea>
        <button type="button" (click)="fetchGeo()" class="btn btn-block btn-sm btn-secondary" [disabled]="geocoding">
          <span *ngIf="!geocoding">Quick Search</span>
          <span *ngIf="geocoding">
            <i class="fas fa-spinner fa-pulse fa-fw"></i> Searching...
          </span>
        </button>
      </div>
    </div>
  </div>
  <div class="form-group">
    <label>Care of</label>
    <app-contact-search [contactId]="address.care_of_id" (contact_id)="address.care_of_id = $event" [small_input]="true"></app-contact-search>
  </div>
  <app-form-text-input label="Attention" [small]="true" [(model)]="address.attention"></app-form-text-input>
  <div class="form-group">
    <label>Types</label>
    <div class="custom-control custom-checkbox" (click)="addressType.selected = !addressType.selected" *ngFor="let addressType of formOptions.address_types">
      <input type="checkbox" class="custom-control-input" [checked]="addressType.selected" />
      <label class="custom-control-label">{{ addressType.label }}</label>
    </div>
  </div>
  <app-form-text-input label="Building" [small]="true" [(model)]="address.building"></app-form-text-input>
  <app-form-text-input label="Suite" [small]="true" [(model)]="address.suite"></app-form-text-input>
  <app-form-text-input label="Floor" [small]="true" [(model)]="address.floor"></app-form-text-input>
  <app-form-text-input label="Street" [small]="true" [(model)]="address.street"></app-form-text-input>
  <app-form-text-input label="P.O. Box" [small]="true" [(model)]="address.po_box"></app-form-text-input>
  <div class="form-group">
    <label>City</label>
    <input type="text" name="city" [(ngModel)]="address.city" required class="form-control form-control-sm" />
    <div class="invalid-feedback d-block" *ngIf="!address.city && formSubmitted">City is required</div>
  </div>
  <div class="form-group">
    <label>State</label>
    <input #state="ngModel" type="text" name="state" [(ngModel)]="address.state" required minlength="2" maxlength="2" class="form-control form-control-sm" />
    <div class="invalid-feedback d-block" *ngIf="!address.state && formSubmitted">
      <div *ngIf="state && state.errors && state.errors.required">State is required</div>
      <div *ngIf="state && state.errors && (state.errors.minlength || state.errors.maxlength)">State must be two letters</div>
    </div>
  </div>
  <div class="form-group">
    <label>Postal Code</label>
    <input type="text" name="postal_code" [(ngModel)]="address.postal_code" required class="form-control form-control-sm" />
    <div class="invalid-feedback d-block" *ngIf="!address.postal_code && formSubmitted">Postal code is required</div>
  </div>
  <app-form-text-input label="Country" [small]="true" [(model)]="address.country"></app-form-text-input>
  <app-form-text-input label="County" [small]="true" [(model)]="address.county"></app-form-text-input>
  <app-form-text-input label="Township" [small]="true" [(model)]="address.township"></app-form-text-input>
  <app-form-text-input label="Province" [small]="true" [(model)]="address.province"></app-form-text-input>
  <app-form-text-input label="Identity Code" [small]="true" [(model)]="address.identity_code"></app-form-text-input>
  <app-form-text-input label="Calendar Color" [small]="true" [(model)]="address.color_code"></app-form-text-input>
  <div class="form-row">
    <div class="col">
      <button type="button" (click)="save(currentForm)" class="btn btn-primary btn-block" [disabled]="formSubmitting">
        Save
        <span *ngIf="formSubmitting">
          &nbsp;
          <i class="fas fa-pulse fa-spinner fa-fw"></i>
        </span>
      </button>
    </div>
    <div class="col">
      <button type="button" class="btn btn-outline-secondary btn-block" [disabled]="formSubmitting" (click)="saved.emit(false)">Cancel</button>
    </div>
  </div>
</form>
